import { IconButton } from '@mui/material';
import { FC } from 'react';
import EditIcon from '../../../../icons/svg/edit.svg?react';

type Props = {
  onClick: () => void;
};

export const EditButton: FC<Props> = ({ onClick }) => {
  return (
    <IconButton disableRipple onClick={onClick} aria-label="Edit">
      <EditIcon />
    </IconButton>
  );
};
